<template>
  <el-dialog
    title="收货缺陷"
    custom-class="receipt-defect-dialog"
    :visible.sync="dialogVisible"
    width="960px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="defect-tip">仅展示未齐收或存在质检不合格 / 缺货的明细；缺货数量=采购数量-已累计实收-已累计质检不合格；采购数量=已累计实收且质检不合格=0、缺货=0 的记录已隐藏</div>
    <el-table
      :data="skuList"
      border
      stripe
      size="mini"
      max-height="480"
      show-summary
      :summary-method="getSummaries"
      v-loading="loading"
      element-loading-text="加载中..."
      class="defect-table"
    >
      <el-table-column type="index" label="序号" width="48" align="center"></el-table-column>
      <el-table-column prop="date" label="采购日期" width="90" align="center"></el-table-column>
      <el-table-column prop="productName" label="产品名称" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseColorName" label="颜色" width="80" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="model" label="型号" width="90" align="left" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseQuantity" label="采购数量" width="90" align="right"></el-table-column>
      <el-table-column prop="prevBatchArrived" label="已累计实收" width="100" align="right"></el-table-column>
      <el-table-column prop="prevQualityFail" label="已累计质检不合格" width="130" align="right"></el-table-column>
      <el-table-column prop="outOfStock" label="缺货数量" width="90" align="right"></el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { requestModules } from "@r";

const SUM_PROPS = ["purchaseQuantity", "prevBatchArrived", "prevQualityFail", "outOfStock"];

export default {
  name: "ReceiptDefectDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      skuList: [],
    };
  },
  methods: {
    open(selectedList) {
      this.dialogVisible = true;
      this.skuList = [];
      this.loadSkus(selectedList || []);
    },
    loadSkus(selectedList) {
      this.loading = true;
      requestModules
        .fetchPurchaseOrderReceiptDefectSkus({
          selectedList: JSON.stringify(selectedList),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取收货缺陷明细失败");
            this.dialogVisible = false;
            return;
          }
          this.skuList = res.ldata || [];
          if (!this.skuList.length) {
            this.$message.info("所选采购单没有需要关注的收货缺陷明细");
          }
        })
        .catch(() => {
          this.$message.error("获取收货缺陷明细失败");
          this.dialogVisible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSummaries({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (SUM_PROPS.includes(column.property)) {
          sums[index] = (data || []).reduce((total, row) => total + (Number(row[column.property]) || 0), 0);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    handleClose() {
      this.skuList = [];
    },
  },
};
</script>

<style lang="scss">
.receipt-defect-dialog {
  .el-dialog__body {
    padding: 12px 16px;
  }

  .defect-tip {
    margin-bottom: 10px;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
  }

  .defect-table {
    width: 100%;
  }
}
</style>
